import { styled } from 'stitches.config'

export const RadioOptionsWrapperRoot = styled('div', {
  display: 'flex',
  justifyContent: 'flex-start',
  maxWidth: '280px',
  gap: '$2',
  flexWrap: 'wrap',

  '@bp1': {
    justifyContent: 'center',
    maxWidth: '100%',
  },
})
